import { z } from 'zod';
/**
 * Globale Suche (Kopfleiste): ein Suchbegriff durchsucht alle Bereiche, die der Benutzer sehen darf. Der Server liefert je Art einige Treffer, die Oberfläche gruppiert sie und
 * führt mit dem Pfad auf die Seite. Seiten und Einrichtungsbereiche sucht die Oberfläche selbst.
 */
export const SEARCH_KINDS = ['contact', 'inquiry', 'offer', 'order', 'invoice', 'purchase', 'product', 'employee', 'task', 'document', 'vehicle', 'asset'];
export const SEARCH_KIND_LABELS = {
    contact: 'Kontakte',
    inquiry: 'Anfragen',
    offer: 'Angebote',
    order: 'Aufträge',
    invoice: 'Ausgangsrechnungen',
    purchase: 'Eingangsrechnungen',
    product: 'Produkte',
    employee: 'Mitarbeiter',
    task: 'Aufgaben',
    document: 'Dokumente',
    vehicle: 'Fahrzeuge',
    asset: 'Inventar',
};
export const globalSearchQuery = z.object({
    q: z.string().trim().min(2, 'Bitte mindestens 2 Zeichen eingeben').max(100),
    /** Treffer je Art, höchstens 10 */
    limit: z.coerce.number().int().min(1).max(10).default(5),
});
/** Klein geschrieben, ohne Umlaute und Akzente, ß als ss: „Müller“ und „muller“ sind für die Suche dasselbe. Server und Oberfläche falten gleich. */
export const foldSearchText = (text) => text
    .toLocaleLowerCase('de-DE')
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
//# sourceMappingURL=search.js.map